import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_toolbar = _resolveComponent("game-toolbar")!
  const _component_square_panel = _resolveComponent("square-panel")!
  const _component_keyboard_component = _resolveComponent("keyboard-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_game_toolbar, {
      onOnChartPressed: _ctx.showStats,
      onOnHelpPressed: _ctx.showHelp,
      onOnSettingsPressed: _ctx.showSettings
    }, null, 8, ["onOnChartPressed", "onOnHelpPressed", "onOnSettingsPressed"]),
    _createVNode(_component_square_panel, {
      squareController: _ctx.gameData.square,
      onOnGuessCountPressed: _ctx.showGuesses
    }, null, 8, ["squareController", "onOnGuessCountPressed"]),
    _createVNode(_component_keyboard_component, {
      keyboardData: _ctx.gameData.square.keyboardData,
      onOnLetterPressed: _ctx.addLetter,
      onOnBackPressed: _ctx.removeLetter,
      onOnEnterPressed: _ctx.submit
    }, null, 8, ["keyboardData", "onOnLetterPressed", "onOnBackPressed", "onOnEnterPressed"])
  ], 64))
}